import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { AppointmentResponse, Appointments } from '../types';
type UseBusinessOptions = {
  businessId?: number;
  startDate?: Date;
  endDate?: Date;
  page: number;
  perPage: number;
  type: number;
  isRoomBooking?: boolean;
};
export const getEvents = (
  {startDate, endDate, page, perPage, type, isRoomBooking }: UseBusinessOptions = {
    page: 1,
    perPage: 10,
    type:0,
    isRoomBooking: false
  }
): Promise<AppointmentResponse> => {
  const url = isRoomBooking ? 'parent/rooms/bookings?' : '/parent/appointments?'
  return axios.get(
    type == 1
    ? `${url}completed=true`
      : type == 2
      ? `${url}cancelled=true`
      : type == 3
      ? `${url}requested=true`
      : `${url}accepted= true`,
    {
      params: { start: startDate, end: endDate, page, perPage },
    }
  );
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getEvents>;
};

export const useGetAppointments = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getEvents,
  });
};
